import { scrollToContacto } from "./scroll";

export default function CtaBand({ title, text, buttonLabel = "Solicitar cotización" }) {
  return (
    <section className="kn-cta-band">
      <div className="kn-container kn-cta-band-inner">
        <div data-reveal="left">
          <h2>{title}</h2>
          {text && <p>{text}</p>}
        </div>
        <button
          type="button"
          data-reveal="right"
          className="kn-btn-primary kn-btn-primary--block kn-btn-primary--mobile-full"
          onClick={scrollToContacto}
        >
          {buttonLabel}
        </button>
      </div>
    </section>
  );
}

export function StickyCta() {
  return (
    <div className="kn-sticky-cta">
      <button
        type="button"
        className="kn-btn-primary kn-btn-primary--block"
        onClick={scrollToContacto}
      >
        Cotizar
      </button>
    </div>
  );
}
